const dashboardMenu = [
  {
    "label": "Finance Monitoring",
    "link": "/dashboard",
    "icon": "ri-pie-chart-2-line"
  },
];

const pagesMenu = [
  {
    "label": "Expenses",
    "link": "/dashboard/expense",
    "icon": "ri-money-dollar-circle-line"
  },
  {
    "label": "Income",
    "link": "/dashboard/income",
    "icon": "ri-funds-line"
  },
  {
    "label": "Bill",
    "link": "/dashboard/bill",
    "icon": "ri-bill-line"
  },
  {
    "label": "Goal",
    "link": "/dashboard/goal",
    "icon": "ri-flag-2-line"
  },
  {
    "label": "Budget",
    "link": "/dashboard/budget",
    "icon": "ri-wallet-line"
  },
  {
    "label": "Reports",
    "icon": "ri-file-chart-line",
    "submenu": [
      {
        "label": "Financial Report",
        "link": "/dashboard/reports/financial"
      }
    ]
  },
  {
    "label": "AI Features",
    "icon": "ri-brain-line",
    "link": "/dashboard/ai",
    "submenu": [
      {
        "label": "AI Assistant",
        "link": "/dashboard/ai/chat",
        "icon": "ri-robot-line",
        "premium": true,
        "description": "Chat with AI for financial advice"
      },
      // {
      //   "label": "Expense Forecast",
      //   "link": "/ai/forecast",
      //   "icon": "ri-line-chart-line",
      //   "premium": true,
      //   "description": "AI-powered expense predictions"
      // },
      {
        "label": "Smart Insights",
        "link": "/dashboard/ai/insights",
        "icon": "ri-lightbulb-flash-line",
        "premium": true,
        "description": "AI analysis of your finances"
      },
      // {
      //   "label": "Budget Optimizer",
      //   "link": "/ai/optimizer",
      //   "icon": "ri-funds-box-line",
      //   "premium": true,
      //   "description": "AI-optimized budget recommendations"
      // },
      {
        "label": "Debt Strategy",
        "link": "/dashboard/ai/debt-strategy",
        "icon": "ri-money-dollar-circle-line",
        "premium": true,
        "description": "AI debt repayment optimization"
      }
    ]
  },
  {
    "label": "Settings",
    "icon": "ri-settings-2-line",
    "link": "/dashboard/settings"
  },
  {
    "label": "Contact Us",
    "link": "/dashboard/contact",
    "icon": "ri-customer-service-2-line"
  },
];

export { dashboardMenu, pagesMenu };
